import {useCallback} from 'react';
import {useKiosko} from '../useKiosko';
import {useKioskoStore} from '../useKioskoStore';

export const useDispenserControls = () => {
  const {sendMessage} = useKiosko();

  const {
    connection: {isConnected, error},
    apiKey,
    setPrinterState,
  } = useKioskoStore();

  const initializeDispenser = useCallback(() => {
    if (!isConnected) {
      console.warn('⚠️ Cannot initialize dispenser: WebSocket not connected');
      return false;
    }
    return sendMessage('dispenser_initialize', {}, apiKey);
  }, [isConnected, sendMessage, apiKey]);

  const moveToGate = useCallback(() => {
    if (!isConnected) {
      console.warn('⚠️ Cannot move to gate: WebSocket not connected');
      return false;
    }
    return sendMessage('dispenser_command', {command: 'move_to_gate'}, apiKey);
  }, [isConnected, sendMessage, apiKey]);

  const printCard = useCallback(() => {
    if (!isConnected) {
      console.warn('⚠️ Cannot print card: WebSocket not connected');
      return false;
    }
    setPrinterState({isPrinting: true});
    return sendMessage(
      // 'fake_print_card',
      'print_card',
      {
        room_number: '101',
        guest_name: 'Test Guest',
      },
      apiKey,
    );
  }, [isConnected, sendMessage, apiKey, setPrinterState]);

  return {
    isConnected,
    error,
    initializeDispenser,
    moveToGate,
    printCard,
  };
};
